import axios from 'axios';

export const CE_TRASH = 'CE_TRASH';
export const E_TRASH = 'E_TRASH';
export const RESTORE_CAMPAIGN = 'RESTORE_CAMPAIGN'
export const SET_VARIABLES_TRASH = "SET_VARIABLES_TRASH"
export const RESTORE_EDITION = 'RESTORE_EDITION'
export const MEDIA_TRASH = 'MEDIA_TRASH'
export const MEDIA_TRASH_PARENT = 'MEDIA_TRASH_PARENT'
export const DELETE_FILE_IN_TRASH = 'DELETE_FILE_IN_TRASH'
export const DELETE_FOLDER_IN_TRASH = 'DELETE_FOLDER_IN_TRASH'
export const RESTORE_FOLDER = "RESTORE_FOLDER"
export const RESTORE_FILE = "RESTORE_FILE"
export const DELETE_ALL = "DELETE_ALL"
export const DELETE_EDITION_IN_TRASH = "DELETE_EDITION_IN_TRASH"



export function getTrashCampaignsAndEditions(client) {
  return {
    type: CE_TRASH,
    payload: axios.get(`/api/deleteds/main/campaigns/and/editions.json`).then(({ data }) => data),
  };
}

export function getTrashEditions(campaignId) {
  return {
    type: E_TRASH,
    payload: axios.get('/api/deleteds/' + campaignId + '/campaigns/and/editions.json').then(({ data }) => data),
  };
}
// neuer root put campaign trash
export function restoreCampaignR(campaignId) {
  return {
    type: RESTORE_CAMPAIGN,
    payload:   axios.put('/api/campaigns/' + campaignId + '/trash.json').then(({ data }) => data),
  };
}

//
export function restoreEditionR(editionId, campaignId) {
  return {
    type: RESTORE_EDITION,
    payload:   axios.put('/api/editions/' + editionId + '/trashes/' + campaignId + '.json').then(({ data }) => data),
  };
}

export function deleteEditionR(editionId, flagOption) {
  return {
    type: DELETE_EDITION_IN_TRASH,
    payload:   axios.delete('/api/news/' + editionId + '/editions/' + flagOption + '.json').then(({ data }) => data),
  };
}


export function setVariablesTrash(key, id){
  let data = [key, id]
  return{
    type: SET_VARIABLES_TRASH,
    payload: data,
  }
}

export function getTrashMedia(x){
  return {
    type: MEDIA_TRASH,
    payload: axios.get(`/api/deleteds/main/medialibrary.json`).then(({data}) => data),
  }
}

export function getTrashMediaOfParent($filter){
  return {
    type: MEDIA_TRASH_PARENT,
    payload: axios.get('/api/deleteds/' + $filter + '/medialibrary.json').then(({data}) => data),
  }
}

export function deleteFile(id) {
  return {
    type: DELETE_FILE_IN_TRASH,
    payload: axios.delete('/api/medialibraries/' + id + '/images/delete.json').then(({ data }) => data),
  };
}

export function deleteFolder(id) {
  return {
    type: DELETE_FOLDER_IN_TRASH,
    payload: axios.delete('/api/medialibraries/' + id + '/folders/delete.json').then(({ data }) => data),
  };
}


export function restoreFolderR(folderId) {
  return {
    type: RESTORE_FOLDER,
    payload: axios.put('/api/medialibraries/' + folderId + '/trashes/folder/file.json').then(({ data }) => data),
  };
}

export function restoreFileR(fileId) {
  return {
    type: RESTORE_FILE,
    payload: axios.put('/api/medialibraries/' + fileId + '/trashes/media/file.json').then(({ data }) => data),
  };
}

export function deleteAllR(x) {
return {
  type: DELETE_ALL,
  payload: axios.delete('/api/trash.json').then(({ data }) => data),
};
}



